export class BillingScheme {
    accounts: Array<any> | null;
    billingsettings: Array<any>;
    cancheckbalance: boolean;
    fields: null | Array<any>;
    id: number;
    name: string;
    supportsfulladdresscollection: boolean;
    supportsolopay: boolean;
    supportssaveonfile: boolean;
    supportstokens: boolean;
    type: string;

    public static Make(obj: any): BillingScheme {
        const billingScheme = new BillingScheme();
        Object.assign(billingScheme, obj);
        return billingScheme;
    }
}
